/**
 * Returns true if the user is already on the given Centra market (locale + country),
 * meaning no market change is needed and the click should be a no-op.
 *
 * For xx-yy locales (e.g. en-dk): locale segment alone is sufficient.
 * For single-segment locales (e.g. en, de, fr): basketSessionCountryCode is required
 * to distinguish between countries that share the same locale path.
 */
export function isCurrentCentraMarket(
    targetPath: string,
    targetCountryCode: string,
    basketSessionCountryCode: string | undefined
): boolean {
    const currentLocale = window.location.pathname.split("/")[1]
    const targetLocale = targetPath.replace(/^\/+/, "")

    if (currentLocale !== targetLocale) return false

    return (
        !!basketSessionCountryCode &&
        basketSessionCountryCode.toLowerCase() === targetCountryCode.toLowerCase()
    )
}
